import React from "react";
import { object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./social-share.m.css";

import Whatsapp from "../../atoms/social-media-icons/Whatsapp";
import Facebook from "../../atoms/social-media-icons/Facebook";
import Twitter from "../../atoms/social-media-icons/Twitter";
import Telegram from "../../atoms/social-media-icons/Telegram";
import Youtube from "../../atoms/social-media-icons/Youtube";
import Instagram from "../../atoms/social-media-icons/Instagram";
import LinkedIn from "../../atoms/social-media-icons/LinkedIn";

const SocialShareIcons = ({ socialLinks, socials }) => {
  if (!socialLinks) {
    return null;
  }

  const list = [
    {
      Type: <Whatsapp height="21px" width="21px" color="#444" isShareRequired={false} />,
      url: socials?.whatsapp?.url || socialLinks["whatsapp-url"],
      name: "Whatsapp"
    },
    {
      Type: <Facebook height="21px" width="21px" color="#444" isShareRequired={false} />,
      url: socials?.facebook?.url || socialLinks["facebook-url"],
      name: "Facebook"
    },
    {
      Type: <Twitter height="21px" width="21px" color="#444" isShareRequired={false} />,
      url: socials?.twitter?.url || socialLinks["twitter-url"],
      name: "Twitter"
    },
    {
      Type: <Instagram height="21px" width="21px" color="#444" isShareRequired={false} />,
      url: socials?.instagram?.url || socialLinks["instagram-url"],
      name: "Instagram"
    },
    {
      Type: <Youtube height="21px" width="30px" color="#444" isShareRequired={false} />,
      url: socials?.youtube?.url || socialLinks["youtube-url"],
      name: "Youtube"
    },
    {
      Type: <Telegram height="21px" width="21px" color="#444" isShareRequired={false} />,
      url: socials?.telegram?.url || socialLinks["telegram-url"],
      name: "Telegram"
    },
    {
      Type: <LinkedIn height="21px" width="21px" color="#444" isShareRequired={false} />,
      url: socials?.linkedin?.url || socialLinks["linkedin-url"],
      name: "LinkedIn"
    }
  ];

  return (
    <div styleName="wrapper" className="social-icons-wrapper">
      {list
        .filter(item => item.url)
        .map(({ url, Type, name }) => (
          <a
            key={name}
            href={url}
            styleName="social-link-item"
            className={`social-link-item ${name.toLowerCase()}`}
            target="_blank"
            rel="nofollow noreferrer"
            aria-label={name}
          >
            {Type}
          </a>
        ))}
    </div>
  );
};

SocialShareIcons.propTypes = {
  socialLinks: object,
  socials: object
};

const mapStateToProps = (state) => ({
  socialLinks: get(state, ["qt", "config", "social-links"], {})
});

export default connect(mapStateToProps)(SocialShareIcons);
